<template>
    <div>
        <div v-if="msgInfo?.content_type == 'dy_one_click'">
            {{ msgInfo.reply_content }}
            <div class="m_desc">
                【抖音一键留资】- {{ msgInfo.rule_name }}
            </div>
        </div>
        <div v-else>
            暂不支持的卡片类型
        </div>
    </div>
</template>
<script>
// 引入动态组件（中间栏）
import { toRefs, onMounted, reactive, computed, inject } from "vue";
import defaultImage from '@/assets/img/error_icon.jpg'
import _ from 'lodash';
export default {
    components: {},
    setup() {
        const $tauriWindow = inject('tauriWindow')
        const msgItem = inject('msgItem')
        const data = reactive({

        });
        const msgInfo = computed(() => {
            let msg = msgItem?.msg || {}
            if (_.isObject(msg)) {
                return msg
            }
            try {
                return JSON.parse(msg)
            } catch (e) {
                console.error(e)
                return {}
            }
        })
        // ----------- 方法 -----------
        const handleGoDetail = (url) => {
            if (!url) {
                return
            }
            $tauriWindow.openWindow(url)
        }

        onMounted(() => { });


        return {
            ...toRefs(data),
            msgItem,
            msgInfo,
            defaultImage,
            handleGoDetail
        };
    },
};
</script>

<style lang="scss" scoped>
.img_c {
    display: flex;
    justify-content: flex-end;
}

.img_c img {

    width: 200px;
    height: 200px;
    object-fit: fill;
}

.msg_c {
    display: flex;
    justify-content: center;
}
</style>